export class ExchangeModel {
cmbExchange: string;
setValue(res){
if(res){
if(res['cmbExchange']){this.cmbExchange = res['cmbExchange'];}
}
}
}